"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class EmailInputValidator {
  validatePattern = value => {
    const regexPattern = /^[a-z0-9.\-_]+@[\w.-]+\.[a-z0-9]{2,}$/;
    return regexPattern.test(value);
  };
}
const emailInputValidator = new EmailInputValidator();
var _default = exports.default = emailInputValidator;